import Entity from './entity';
import { computed } from '@ember/object';
import { hash, htmlEscape } from '@intercom/pulse/lib/computed-properties';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
import uriEncodeAttributes from './../../lib/computed-properties/uri-encode-attributes';
import Em from 'ember';
export default Entity.extend({
  precedence: 4,
  isMention: true,
  isMergeable: false,
  type: 'mention',
  tagName: 'ic-mention',
  serializedTagName: 'a',
  attributesToCopy: ['href'],
  options: hash('href'),
  encodedHref: uriEncodeAttributes('href'),
  htmlEscapedHref: htmlEscape('encodedHref'),
  hasNonEditableContainer: true,
  additionalAttributes: computed('htmlEscapedHref', function () {
    return `class="entity_mention" contenteditable="false" href="${this.htmlEscapedHref}"`;
  }),
  serializedAttributes: computed('htmlEscapedHref', function () {
    return `class="entity_mention" href="${this.htmlEscapedHref}"`;
  }),
  updateForDelete(block, deletedBlockRange) {
    let delta = deletedBlockRange.get('length');
    if (this.isAdjacentRightOfRange(deletedBlockRange)) {
      this.shiftLeftBy(delta);
      return;
    }
    if (this.isAdjacentLeftOfRange(deletedBlockRange)) {
      return;
    }
    if (this.containedIn(deletedBlockRange)) {
      this.empty();
      return;
    }
    if (this.intersectsLeft(deletedBlockRange)) {
      block.insertCharacter(BlockRange.atPositionIndex(this.get('startIndex')), {
        character: '@'
      });
      deletedBlockRange.shiftRightBy(1);
      this.empty();
      return;
    }
    this.empty();
  },
  adminId: Em.computed('href', function () {
    let regexp = new RegExp(/\/([0-9]+)$/);
    let result = regexp.exec(this.get('href'));
    if (result) {
      return result.pop();
    }
  })
});